import React from 'react'
import { aboutData } from './data'

const AboutBody = () => {
  return (
    <div className='py-8 sm:py-10 md:py-12 lg:py-16'>
      {aboutData.map((about, index) => (
        <div className='' key={index}>
          <h1 className='font-semibold text-3xl sm:text-4xl md:text-5xl pb-4'>
            {about.title}
          </h1>
          <p className='text-base text-gray-500 leading-loose pb-8  md:text-xl sm:text-lg'>
            {about.body}
          </p>
          <img src={about.img} alt='' className='mb-5' />
        </div>
      ))}
    </div>
  )
}

export default AboutBody
